import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowPathIcon, TrashIcon } from '@heroicons/react/24/outline';
import Modal from '../../../../../components/ui/Modal';
import { sessionsApi } from '../../../../../api/sessionsApi';

export default function DeleteSessionModal({ session, isOpen, onClose, notify }) {
  const navigate = useNavigate();
  const [isDeleting, setIsDeleting] = useState(false);

  const confirm = async () => {
    setIsDeleting(true);
    try {
      await sessionsApi.remove(session.id);
      notify({ type: 'success', title: 'Session deleted', message: 'Session has been permanently deleted' });
      onClose();
      setTimeout(() => navigate('/sessions'), 1500);
    } catch (e) {
      notify({ type: 'error', title: 'Failed to delete session', message: e.message });
      setIsDeleting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Delete session?" size="sm">
      <div className="bg-red-50 border border-red-200 rounded-lg p-3 mb-4 text-sm text-red-800 font-medium">
        This is permanent and cannot be undone.
      </div>
      <p className="text-gray-700 mb-2">This deletes the whole session:</p>
      <ul className="list-disc list-inside text-sm text-gray-600 space-y-1 mb-3">
        <li>All transcripts and their versions</li>
        <li>Generated reports</li>
        <li>All associated metadata</li>
      </ul>
      <p className="text-gray-700 font-semibold">{session.title || `Session ${session.id}`}</p>

      <div className="flex gap-3 mt-6">
        <button
          type="button"
          onClick={onClose}
          disabled={isDeleting}
          className="flex-1 px-4 py-2 text-gray-700 bg-gray-100 border border-gray-300 rounded-lg hover:bg-gray-200 disabled:opacity-50"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={confirm}
          disabled={isDeleting}
          className="flex-1 px-4 py-2 text-white bg-red-600 rounded-lg hover:bg-red-700 disabled:opacity-50 inline-flex items-center justify-center gap-2"
        >
          {isDeleting ? <ArrowPathIcon className="h-5 w-5 animate-spin" /> : <TrashIcon className="h-5 w-5" />}
          {isDeleting ? 'Deleting...' : 'Delete session'}
        </button>
      </div>
    </Modal>
  );
}
